import { render, staticRenderFns } from "./SecureAccessPage.vue?vue&type=template&id=1d8ea5d0&scoped=true"
import script from "./SecureAccessPage.vue?vue&type=script&lang=js"
export * from "./SecureAccessPage.vue?vue&type=script&lang=js"
import style0 from "./SecureAccessPage.vue?vue&type=style&index=0&id=1d8ea5d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8ea5d0",
  null
  
)

export default component.exports